export default {
  "Product Name": "Name",
}
